// extracted by mini-css-extract-plugin
export default {"listgenBanner":"landing_listgenBanner__q4cxT"};